<!-- 监测指标数据跟踪 -->
<template>
  <div class="container">
    <div class="btn-box">
      <el-button type="primary" @click="back">返回</el-button>
    </div>
    <div class="main-box">
      <div>
        <h4>{{ lastDate }}“{{ nowDetailData.zykName }}”资源库基础建设数据统计分析情况</h4>
        <div class="table-box">
          <table v-if="lastDetailData.declBuildBaseInfo">
            <tr class="tr-head">
              <td colspan="3">一、资源库基本信息</td>
            </tr>
            <tr>
              <td>当前级别</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.projectType }}
              </td>
            </tr>
            <tr>
              <td>上线时长（学期）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.standardCourseTime }}
              </td>
            </tr>
            <tr>
              <td>接入国家职业教育智慧教育平台</td>
              <td colspan="2">
                {{ lastDetailData.joinCountryPlatform }}
                <!-- <el-radio-group v-model="lastDetailData.joinCountryPlatform">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group> -->
              </td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">二、资源建设与应用情况</td>
            </tr>
            <tr>
              <td>资源总量</td>
              <td colspan="2">{{ lastDetailData.resourceBuild.resourceCount }}</td>
            </tr>
            <tr>
              <td>文本类/图形图像</td>
              <td>{{ lastDetailData.resourceBuild.textVo.sumValue }}</td>
              <td>{{ lastDetailData.resourceBuild.textVo.percentage }}</td>
            </tr>
            <tr>
              <td>文本型演示文稿（ppt、网页课件与富媒体等）</td>
              <td>{{ lastDetailData.resourceBuild.textPPTVo.sumValue }}</td>
              <td>{{ lastDetailData.resourceBuild.textPPTVo.percentage }}</td>
            </tr>
            <tr>
              <td>动画类</td>
              <td>{{ lastDetailData.resourceBuild.animationVo.sumValue }}</td>
              <td>{{ lastDetailData.resourceBuild.animationVo.percentage }}</td>
            </tr>
            <tr>
              <td>虚拟仿真类</td>
              <td>{{ lastDetailData.resourceBuild.virtualVo.sumValue }}</td>
              <td>{{ lastDetailData.resourceBuild.virtualVo.percentage }}</td>
            </tr>
            <tr>
              <td>音频类</td>
              <td>{{ lastDetailData.resourceBuild.audioVo.sumValue }}</td>
              <td>{{ lastDetailData.resourceBuild.audioVo.percentage }}</td>
            </tr>
            <tr>
              <td>视频类</td>
              <td>{{ lastDetailData.resourceBuild.videoVo.sumValue }}</td>
              <td>{{ lastDetailData.resourceBuild.videoVo.percentage }}</td>
            </tr>
            <tr>
              <td>微课类</td>
              <td>{{ lastDetailData.resourceBuild.smallCourseVo.sumValue }}</td>
              <td>{{ lastDetailData.resourceBuild.smallCourseVo.percentage }}</td>
            </tr>
            <tr>
              <td>其他</td>
              <td>{{ lastDetailData.resourceBuild.otherVo.sumValue }}</td>
              <td>{{ lastDetailData.resourceBuild.otherVo.percentage }}</td>
            </tr>
            <tr>
              <td>原创资源占比</td>
              <td colspan="2">
                {{ lastDetailData.resourceBuild.originVo.percentage }}
              </td>
            </tr>
            <tr>
              <td>资源被课程引用的占比</td>
              <td colspan="2">
                {{ lastDetailData.resourceBuild.courseResourceVo.percentage }}
              </td>
            </tr>
            <tr>
              <td>资源内容存储总量（GB）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.resourceSave }}
              </td>
            </tr>
            <tr>
              <td>文本型演示文稿、图形（像）类和文本类资源量（GB）</td>
              <td colspan="2">{{ lastDetailData.declBuildBaseInfo.textImage }}</td>
            </tr>
            <tr>
              <td>专业人才培养方案（份）</td>
              <td colspan="2">
                {{ lastDetailData.professionTrain }}
                <!-- <el-input v-model="lastDetailData.professionTrain" placeholder="请输入" size="small" /> -->
              </td>
            </tr>
            <tr>
              <td>标准化课程的知识图谱（份）</td>
              <td colspan="2">
                {{ lastDetailData.standardCourseAtlas }}
                <!-- <el-input v-model="lastDetailData.standardCourseAtlas" placeholder="请输入" size="small" /> -->
              </td>
            </tr>
            <tr>
              <td>课程教学标准或规范（份）</td>
              <td colspan="2">
                {{ lastDetailData.courseTeachStandard }}
                <!-- <el-input v-model="lastDetailData.courseTeachStandard" placeholder="请输入" size="small" /> -->
              </td>
            </tr>
            <tr>
              <td>资源访问总量</td>
              <td colspan="2">{{ lastDetailData.resourceBuild.resourceVisit }}</td>
            </tr>
            <tr>
              <td>无活动资源数</td>
              <td colspan="2">
                {{ lastDetailData.resourceBuild.noActiveResource }}
              </td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">三、课程建设与应用情况</td>
            </tr>
            <tr>
              <td>课程总数（门）</td>
              <td colspan="2">
                {{
                  +lastDetailData.declBuildBaseInfo.standardNum +
                  +lastDetailData.declBuildBaseInfo.majorCoreNum
                }}
              </td>
            </tr>
            <tr>
              <td>标准化课程（门）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.standardNum }}
              </td>
            </tr>
            <tr>
              <td>专业核心课程（门）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.majorCoreNum }}
                <!-- <el-input v-model="lastDetailData.declBuildBaseInfo.majorCoreNum" placeholder="请输入" size="small" /> -->
              </td>
            </tr>
            <tr>
              <td>标准化课程选课总人数（人）</td>
              <td colspan="2">{{ lastDetailData.standardCourseRegNum }}</td>
            </tr>
            <tr>
              <td>无访问标准化课程数（门）</td>
              <td colspan="2">{{ lastDetailData.noActiveStandardNum }}</td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">四、题库建设与应用情况</td>
            </tr>
            <tr>
              <td>题库总数</td>
              <td colspan="2">{{ lastDetailData.questionCount }}</td>
            </tr>
            <tr>
              <td>主观题</td>
              <td colspan="2">{{ lastDetailData.objectiveQ }}</td>
            </tr>
            <tr>
              <td>客观题</td>
              <td colspan="2">{{ lastDetailData.subjectivityQ }}</td>
            </tr>
            <tr>
              <td>题库使用率（%）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.questionBankUseRate }}
              </td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">五、整体应用推广情况</td>
            </tr>
            <tr>
              <td>访问总量（次）</td>
              <td colspan="2">{{ lastDetailData.userVisitNum }}</td>
            </tr>
            <tr>
              <td>用户总数（人）</td>
              <td colspan="2">{{ lastUserTotal }}</td>
            </tr>
            <tr v-for="(item, index) in lastUserTypeArr" :key="index">
              <td>{{ item.name }}总数（人）</td>
              <td colspan="2">{{ item.value }}</td>
            </tr>
            <tr>
              <td>主持单位核心专业与服务专业教师合计人数（人）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.chargeCoreTeacher }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册合计人数（人）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.chargeCoreRealNameTeacher }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册无活动人数（人）</td>
              <td colspan="2">{{ lastDetailData.chargeNoAccessTeacher }}</td>
            </tr>
            <tr>
              <td>主持单位核心专业与服务专业学生合计人数（人）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.chargeCoreStudent }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册合计人数（人）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.chargeCoreRealNameStudent }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册无活动人数（人）</td>
              <td colspan="2">{{ lastDetailData.chargeNoAccessStudent }}</td>
            </tr>
            <tr>
              <td>参与单位核心专业与服务专业教师合计人数（人）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.pitchCoreTeacher }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册合计人数（人）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.pitchRealNameTeacher }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册无活动人数（人）</td>
              <td colspan="2">{{ lastDetailData.buildSchoolNoAccessTeacher }}</td>
            </tr>
            <tr>
              <td>参与单位核心专业与服务专业学生合计人数（人）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.pitchCoreStudent }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册合计人数（人）</td>
              <td colspan="2">
                {{ lastDetailData.declBuildBaseInfo.pitchRealNameStudent }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册无活动人数（人）</td>
              <td colspan="2">{{ lastDetailData.buildSchoolNoAccessTeacher }}</td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">六、年度更新情况</td>
            </tr>
            <tr>
              <td>本年度新增资源数（条）</td>
              <td colspan="2">
                {{ lastDetailData.yearResourceAdd[lastDetailData.yearResourceAdd.length - 1].num }}
              </td>
            </tr>
            <tr>
              <td>本年度资源更新率</td>
              <td colspan="2">
                {{ lastDetailData.yearUpdateRate[lastDetailData.yearUpdateRate.length - 1].num }}
              </td>
            </tr>
            <tr>
              <td>本年度资源内容存储增量（GB）</td>
              <td colspan="2">{{ lastDetailData.yearResourceSpaceAddNum }}</td>
            </tr>
            <tr>
              <td>本年度新增用户数（人）</td>
              <td colspan="2">
                {{ +lastDetailData.yearTeacherAdd + +lastDetailData.yearStudentAdd }}
              </td>
            </tr>
            <tr>
              <td>其中：新增教师数（人）</td>
              <td colspan="2">{{ lastDetailData.yearTeacherAdd }}</td>
            </tr>
            <tr>
              <td>其中：新增学生数（人）</td>
              <td colspan="2">{{ lastDetailData.yearStudentAdd }}</td>
            </tr>
            <tr>
              <td>本年度新增用户占比</td>
              <td colspan="2">{{ lastDetailData.thisYearAddPercentage }}</td>
            </tr>
          </table>
          <table v-else>
            <tr>
              <td colspan="3">暂无数据~</td>
            </tr>
          </table>
        </div>
      </div>
      <div>
        <h4>{{ nowDate }}“{{ nowDetailData.zykName }}”资源库基础建设数据统计分析情况</h4>
        <div class="table-box">
          <table v-if="nowDetailData.declBuildBaseInfo">
            <tr class="tr-head">
              <td colspan="3">一、资源库基本信息</td>
            </tr>
            <tr>
              <td>当前级别</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.projectType }}
              </td>
            </tr>
            <tr>
              <td>上线时长（学期）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.standardCourseTime }}
              </td>
            </tr>
            <tr>
              <td>接入国家职业教育智慧教育平台</td>
              <td colspan="2">
                {{ nowDetailData.joinCountryPlatform }}
                <!-- <el-radio-group v-model="nowDetailData.joinCountryPlatform">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group> -->
              </td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">二、资源建设与应用情况</td>
            </tr>
            <tr>
              <td>资源总量</td>
              <td colspan="2">{{ nowDetailData.resourceBuild.resourceCount }}</td>
            </tr>
            <tr>
              <td>文本类/图形图像</td>
              <td>{{ nowDetailData.resourceBuild.textVo.sumValue }}</td>
              <td>{{ nowDetailData.resourceBuild.textVo.percentage }}</td>
            </tr>
            <tr>
              <td>文本型演示文稿（ppt、网页课件与富媒体等）</td>
              <td>{{ nowDetailData.resourceBuild.textPPTVo.sumValue }}</td>
              <td>{{ nowDetailData.resourceBuild.textPPTVo.percentage }}</td>
            </tr>
            <tr>
              <td>动画类</td>
              <td>{{ nowDetailData.resourceBuild.animationVo.sumValue }}</td>
              <td>{{ nowDetailData.resourceBuild.animationVo.percentage }}</td>
            </tr>
            <tr>
              <td>虚拟仿真类</td>
              <td>{{ nowDetailData.resourceBuild.virtualVo.sumValue }}</td>
              <td>{{ nowDetailData.resourceBuild.virtualVo.percentage }}</td>
            </tr>
            <tr>
              <td>音频类</td>
              <td>{{ nowDetailData.resourceBuild.audioVo.sumValue }}</td>
              <td>{{ nowDetailData.resourceBuild.audioVo.percentage }}</td>
            </tr>
            <tr>
              <td>视频类</td>
              <td>{{ nowDetailData.resourceBuild.videoVo.sumValue }}</td>
              <td>{{ nowDetailData.resourceBuild.videoVo.percentage }}</td>
            </tr>
            <tr>
              <td>微课类</td>
              <td>{{ nowDetailData.resourceBuild.smallCourseVo.sumValue }}</td>
              <td>{{ nowDetailData.resourceBuild.smallCourseVo.percentage }}</td>
            </tr>
            <tr>
              <td>其他</td>
              <td>{{ nowDetailData.resourceBuild.otherVo.sumValue }}</td>
              <td>{{ nowDetailData.resourceBuild.otherVo.percentage }}</td>
            </tr>
            <tr>
              <td>原创资源占比</td>
              <td colspan="2">
                {{ nowDetailData.resourceBuild.originVo.percentage }}
              </td>
            </tr>
            <tr>
              <td>资源被课程引用的占比</td>
              <td colspan="2">
                {{ nowDetailData.resourceBuild.courseResourceVo.percentage }}
              </td>
            </tr>
            <tr>
              <td>资源内容存储总量（GB）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.resourceSave }}
              </td>
            </tr>
            <tr>
              <td>文本型演示文稿、图形（像）类和文本类资源量（GB）</td>
              <td colspan="2">{{ nowDetailData.declBuildBaseInfo.textImage }}</td>
            </tr>
            <tr>
              <td>专业人才培养方案（份）</td>
              <td colspan="2">
                {{ nowDetailData.professionTrain }}
                <!-- <el-input v-model="nowDetailData.professionTrain" placeholder="请输入" size="small" /> -->
              </td>
            </tr>
            <tr>
              <td>标准化课程的知识图谱（份）</td>
              <td colspan="2">
                {{ nowDetailData.standardCourseAtlas }}
                <!-- <el-input v-model="nowDetailData.standardCourseAtlas" placeholder="请输入" size="small" /> -->
              </td>
            </tr>
            <tr>
              <td>课程教学标准或规范（份）</td>
              <td colspan="2">
                {{ nowDetailData.courseTeachStandard }}
                <!-- <el-input v-model="nowDetailData.courseTeachStandard" placeholder="请输入" size="small" /> -->
              </td>
            </tr>
            <tr>
              <td>资源访问总量</td>
              <td colspan="2">{{ nowDetailData.resourceBuild.resourceVisit }}</td>
            </tr>
            <tr>
              <td>无活动资源数</td>
              <td colspan="2">
                {{ nowDetailData.resourceBuild.noActiveResource }}
              </td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">三、课程建设与应用情况</td>
            </tr>
            <tr>
              <td>课程总数（门）</td>
              <td colspan="2">
                {{
                  +nowDetailData.declBuildBaseInfo.standardNum +
                  +nowDetailData.declBuildBaseInfo.majorCoreNum
                }}
              </td>
            </tr>
            <tr>
              <td>标准化课程（门）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.standardNum }}
              </td>
            </tr>
            <tr>
              <td>专业核心课程（门）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.majorCoreNum }}
                <!-- <el-input v-model="nowDetailData.declBuildBaseInfo.majorCoreNum" placeholder="请输入" size="small" /> -->
              </td>
            </tr>
            <tr>
              <td>标准化课程选课总人数（人）</td>
              <td colspan="2">{{ nowDetailData.standardCourseRegNum }}</td>
            </tr>
            <tr>
              <td>无访问标准化课程数（门）</td>
              <td colspan="2">{{ nowDetailData.noActiveStandardNum }}</td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">四、题库建设与应用情况</td>
            </tr>
            <tr>
              <td>题库总数</td>
              <td colspan="2">{{ nowDetailData.questionCount }}</td>
            </tr>
            <tr>
              <td>主观题</td>
              <td colspan="2">{{ nowDetailData.objectiveQ }}</td>
            </tr>
            <tr>
              <td>客观题</td>
              <td colspan="2">{{ nowDetailData.subjectivityQ }}</td>
            </tr>
            <tr>
              <td>题库使用率（%）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.questionBankUseRate }}
              </td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">五、整体应用推广情况</td>
            </tr>
            <tr>
              <td>访问总量（次）</td>
              <td colspan="2">{{ nowDetailData.userVisitNum }}</td>
            </tr>
            <tr>
              <td>用户总数（人）</td>
              <td colspan="2">{{ nowUserTotal }}</td>
            </tr>
            <tr v-for="(item, index) in nowUserTypeArr" :key="index">
              <td>{{ item.name }}总数（人）</td>
              <td colspan="2">{{ item.value }}</td>
            </tr>
            <tr>
              <td>主持单位核心专业与服务专业教师合计人数（人）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.chargeCoreTeacher }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册合计人数（人）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.chargeCoreRealNameTeacher }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册无活动人数（人）</td>
              <td colspan="2">{{ nowDetailData.chargeNoAccessTeacher }}</td>
            </tr>
            <tr>
              <td>主持单位核心专业与服务专业学生合计人数（人）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.chargeCoreStudent }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册合计人数（人）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.chargeCoreRealNameStudent }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册无活动人数（人）</td>
              <td colspan="2">{{ nowDetailData.chargeNoAccessStudent }}</td>
            </tr>
            <tr>
              <td>参与单位核心专业与服务专业教师合计人数（人）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.pitchCoreTeacher }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册合计人数（人）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.pitchRealNameTeacher }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册无活动人数（人）</td>
              <td colspan="2">{{ nowDetailData.buildSchoolNoAccessTeacher }}</td>
            </tr>
            <tr>
              <td>参与单位核心专业与服务专业学生合计人数（人）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.pitchCoreStudent }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册合计人数（人）</td>
              <td colspan="2">
                {{ nowDetailData.declBuildBaseInfo.pitchRealNameStudent }}
              </td>
            </tr>
            <tr>
              <td>其中：实名注册无活动人数（人）</td>
              <td colspan="2">{{ nowDetailData.buildSchoolNoAccessTeacher }}</td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">六、年度更新情况</td>
            </tr>
            <tr>
              <td>本年度新增资源数（条）</td>
              <td colspan="2">
                {{ nowDetailData.yearResourceAdd[nowDetailData.yearResourceAdd.length - 1].num }}
              </td>
            </tr>
            <tr>
              <td>本年度资源更新率</td>
              <td colspan="2">
                {{ nowDetailData.yearUpdateRate[nowDetailData.yearUpdateRate.length - 1].num }}
              </td>
            </tr>
            <tr>
              <td>本年度资源内容存储增量（GB）</td>
              <td colspan="2">{{ nowDetailData.yearResourceSpaceAddNum }}</td>
            </tr>
            <tr>
              <td>本年度新增用户数（人）</td>
              <td colspan="2">
                {{ +nowDetailData.yearTeacherAdd + +nowDetailData.yearStudentAdd }}
              </td>
            </tr>
            <tr>
              <td>其中：新增教师数（人）</td>
              <td colspan="2">{{ nowDetailData.yearTeacherAdd }}</td>
            </tr>
            <tr>
              <td>其中：新增学生数（人）</td>
              <td colspan="2">{{ nowDetailData.yearStudentAdd }}</td>
            </tr>
            <tr>
              <td>本年度新增用户占比</td>
              <td colspan="2">{{ nowDetailData.thisYearAddPercentage }}</td>
            </tr>
          </table>
          <table v-else>
            <tr>
              <td colspan="3">暂无数据~</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      zykId: "",
      nowDate: "", //当月时间
      lastDate: "", //上月时间
      nowDetailData: {}, //当月数据
      lastDetailData: {}, //上月数据
      nowUserTypeArr: [], //当月整体应用推广情况用户类别
      lastUserTypeArr: [], //上月整体应用推广情况用户类别
      nowUserTotal: 0, //当月整体应用推广情况用户总数
      lastUserTotal: 0, //上月整体应用推广情况用户总数
    };
  },
  mounted() {
    this.zykId = sessionStorage.getItem("zykId");
    this.getContrastDeclBuildBaseInfo();
    this.getDeclBuildBaseInfo();
    this.getCurrentDate();
  },
  methods: {
    back() {
      this.$router.push("/monitorIndexDataTrack");
    },
    // 获取上月表格数据
    getContrastDeclBuildBaseInfo() {
      this.$axios
        .post(this.$apiurls.getContrastDeclBuildBaseInfo, this.zykId, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            if (!res.data) return;
            this.lastDetailData = res.data;
            this.lastUserTypeArr = res.data.userTypeNum.filter((item) => item.name !== "其他");
            let sum = 0;
            this.lastUserTypeArr.forEach((item) => {
              sum += item.value;
            });
            this.lastUserTotal = sum;
          }
        });
    },
    // 获取当月表格数据
    getDeclBuildBaseInfo() {
      this.$axios
        .post(this.$apiurls.getDeclBuildBaseInfo, this.zykId, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            if (!res.data) return;
            this.nowDetailData = res.data;
            this.nowUserTypeArr = res.data.userTypeNum.filter((item) => item.name !== "其他");
            let sum = 0;
            this.nowUserTypeArr.forEach((item) => {
              sum += item.value;
            });
            this.nowUserTotal = sum;
          }
        });
    },
    // 获取时间
    getCurrentDate() {
      // 获取当前年月
      let date = new Date();
      let nowYear = date.getFullYear();
      let nowMonth = date.getMonth() + 1;
      nowMonth = nowMonth < 10 ? "0" + nowMonth : nowMonth;
      this.nowDate = `${nowYear}年${nowMonth}月`;
      // 获取上个年月
      date.setMonth(date.getMonth() - 1);
      let lastYear = date.getFullYear();
      let lastMonth = date.getMonth() + 1;
      lastMonth = lastMonth < 10 ? "0" + lastMonth : lastMonth;
      this.lastDate = `${lastYear}年${lastMonth}月`;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  height: 100%;

  .btn-box {
    text-align: right;
    margin-bottom: 20px;

    .el-button {
      height: 32px;
      line-height: 32px;
      padding: 0 20px;
    }
  }

  .main-box {
    height: calc(100% - 52px);
    display: flex;
    justify-content: space-between;

    & > div {
      width: calc(50% - 10px);
    }

    h4 {
      line-height: 20px;
      margin-bottom: 10px;
      color: #fff;
      text-align: center;
    }

    .table-box {
      color: #fff;
      height: calc(100% - 30px);
      overflow: auto;

      table {
        width: 100%;
        margin-bottom: 1px;
        table-layout: fixed;
        border-collapse: collapse;

        tr {
          background-color: rgb(35, 42, 67);

          &:hover {
            transition: all 0.3s;
            background-color: rgba(31, 50, 94, 0.8);
          }

          td {
            height: 38px;
            padding-left: 30px;
            text-align: center;
            border: 1px solid #39456e;

            ::v-deep .el-input__inner {
              height: 28px;
              width: 200px;
              background: rgba(86, 94, 121, 0.59);
              border-color: rgba(86, 94, 121, 0.59);
              color: #e6a23c;
            }
          }
        }

        .tr-head {
          font-weight: bold;
          background-color: rgba(31, 50, 94, 0.8);

          td:first-child {
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
